module.exports = __webpack_public_path__ + "static/media/EditDelegateProfilePic_Default.07c5b922.png";